module.exports = __webpack_public_path__ + "housingStatic/img/park_img2.7f938ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_img2.jpg
// module id = e5ss
// module chunks = 2